import Cookies from 'js-cookie'
import { setStorage } from '@/utils/localStorage'

export const TokenKey = 'trace-token'
export const UserInfoKey = 'trace-userInfo'
export const WeatherDataTypeKey = 'trace-weatherDataType'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getUserInfo () {
  return Cookies.get(UserInfoKey) ? JSON.parse(Cookies.get(UserInfoKey)) : {}
}

export function setUserInfo (userInfo) {
  Cookies.set(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo () {
  Cookies.remove(UserInfoKey)
}

export function setWeatherDataType (info) {
  return setStorage(WeatherDataTypeKey, info)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js